import React, { Fragment, useContext } from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import packageJson from '../../package.json';

import Traductor from '../components/Traductor';
import { UserContext } from '../contexts/UserContext';
import Globals from '../Globals';
import * as filtersActions from '../redux/actions/filters';
import { filterFavorite, filterBidden } from '../constants/Filters';

import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';

import '../components/css/Footer.css';

function FooterModule({
    history,
    cookies,
    reduxFilters,
    setFilters: setReduxFilters,
}) {
    const t = new Traductor();
    const { checkPermission } = usePermissions();
    const { user, setLogged } = useContext(UserContext);

    const logOff = () => {
        cookies.remove(Globals.COOKIES.JWT, { path: process.env.PUBLIC_URL });
        cookies.remove(Globals.COOKIES.USER, { path: process.env.PUBLIC_URL });
        setLogged(false);
        history.push({
            pathname: `${Globals.APPLICATION_PATH.LOGIN}`,
            state: {
                pendingRefresh: true,
            },
        });
    };

    const onClickGoToProfile = type => {
        history.push(Globals.APPLICATION_PATH.PROFILE + '/' + type);
    };

    const onClickGoTodealerReceptor = () => {
        let route = Globals.APPLICATION_PATH.RECEIVINGDEALER;
        if (history.location.pathname != route) {
            setReduxFilters({
                ...reduxFilters[Globals.APPLICATION_PATH.RECEIVINGDEALER]
                    .initial,
                route: Globals.APPLICATION_PATH.RECEIVINGDEALER,
            });
            history.push(route);
        }
    };

    const onClickGoToListVehicles = () => {
        let route = Globals.APPLICATION_PATH.AUCTION;
        if (history.location.pathname != route) {
            setReduxFilters({
                ...reduxFilters[Globals.APPLICATION_PATH.AUCTION].initial,
                [filterBidden]: false,
                [filterFavorite]: false,
                route: [Globals.APPLICATION_PATH.AUCTION],
            });
            history.push(route);
        }
    };

    const onClickGoToAdjudications = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.ADJUDICATIONS].initial,
            route: [Globals.APPLICATION_PATH.ADJUDICATIONS],
        });
        history.push(Globals.APPLICATION_PATH.ADJUDICATIONS);
    };

    const onClickGoToAdjudicationsVWR = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.SOLDVWR].initial,
            route: [Globals.APPLICATION_PATH.SOLDVWR],
        });
        history.push(Globals.APPLICATION_PATH.SOLDVWR);
    };

    const onClickGoToMyBids = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.AUCTION].initial,
            [filterBidden]: true,
            route: [Globals.APPLICATION_PATH.AUCTION],
        });
        history.push({
            pathname: Globals.APPLICATION_PATH.AUCTION + '/Bidden',
        });
    };

    const onClickGoToFavorites = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.AUCTION].initial,
            [filterFavorite]: true,
            route: [Globals.APPLICATION_PATH.AUCTION],
        });
        history.push({
            pathname: Globals.APPLICATION_PATH.AUCTION + '/Favorites',
        });
    };

    const onClickGoToExpirationMatrix = () => {
        let view = Globals.APPLICATION_PATH.HUERTO;
        history.push({
            pathname: Globals.APPLICATION_PATH.HOME,
            state: { view },
        });
    };

    const onClickGoToMyBatches = () => {
        history.push({
            pathname: Globals.APPLICATION_PATH.BATCHES,
        });
    };

    return (
        <footer className="c-footer">
            {user.logged ? (
                <div className="c-footer__module  c-footer__module--nav">
                    <div className="o-page-wrap o-page-wrap--xsmall">
                        <nav className="c-footer-nav">
                            <div className="c-footer-nav__columns">
                                {checkPermission(
                                    'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                                ) ? (
                                    <div className="c-footer-nav__column  js-footer-accordion">
                                        <div className="c-footer-nav__title  js-footer-accordion__title">
                                            <h4 className="c-footer-nav__title-label  js-footer-accordion__title-label">
                                                {t.getTraduction('Subastas')}
                                            </h4>
                                        </div>
                                        <ul className="c-footer-nav__list  js-footer-accordion__panel">
                                            <li className="c-footer-nav__item">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        onClickGoToListVehicles()
                                                    }
                                                >
                                                    {t.getTraduction(
                                                        'ActiveVehicles'
                                                    )}
                                                </a>
                                            </li>

                                            {!checkPermission(
                                                READONLY_PERMISSION
                                            ) && (
                                                <li className="c-footer-nav__item">
                                                    <a
                                                        className="c-footer-nav__link"
                                                        onClick={() =>
                                                            onClickGoToMyBids()
                                                        }
                                                    >
                                                        {t.getTraduction(
                                                            'MyBids'
                                                        )}
                                                    </a>
                                                </li>
                                            )}
                                            {!checkPermission(
                                                READONLY_PERMISSION
                                            ) && (
                                                <li>
                                                    <a
                                                        onClick={
                                                            onClickGoToMyBatches
                                                        }
                                                        className="c-footer-nav__link"
                                                    >
                                                        {t.getTraduction(
                                                            'MyBatches'
                                                        )}
                                                    </a>
                                                </li>
                                            )}

                                            {user.data.Profile &&
                                            user.data.Profile == 12 ? (
                                                <li className="c-footer-nav__item">
                                                    <a
                                                        className="c-footer-nav__link"
                                                        onClick={() =>
                                                            onClickGoTodealerReceptor()
                                                        }
                                                    >
                                                        {t.getTraduction(
                                                            'PurchaseOptionReceiverDealer'
                                                        )}
                                                    </a>
                                                </li>
                                            ) : null}

                                            {!checkPermission(
                                                READONLY_PERMISSION
                                            ) && (
                                                <li className="c-footer-nav__item">
                                                    <a
                                                        className="c-footer-nav__link"
                                                        onClick={() =>
                                                            onClickGoToAdjudications()
                                                        }
                                                    >
                                                        {t.getTraduction(
                                                            'BuyedVehicles'
                                                        )}
                                                    </a>
                                                </li>
                                                
                                            )}
                                            {!checkPermission(
                                                READONLY_PERMISSION
                                            ) && (
                                                <li className="c-footer-nav__item">
                                                    <a
                                                        className="c-footer-nav__link"
                                                        onClick={() =>
                                                            onClickGoToAdjudicationsVWR()
                                                        }
                                                    >
                                                        {t.getTraduction(
                                                            'SoldVehiclesVWR'
                                                        )}
                                                    </a>
                                                </li>
                                                
                                            )}

                                            <li className="c-footer-nav__item">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        onClickGoToFavorites()
                                                    }
                                                >
                                                    {t.getTraduction(
                                                        'Favourits'
                                                    )}
                                                </a>
                                            </li>
                                            <li className="c-footer-nav__item">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        onClickGoToProfile(
                                                            'preferences'
                                                        )
                                                    }
                                                >
                                                    {t.getTraduction(
                                                        'Preferencias'
                                                    )}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                ) : null}
                                {checkPermission(
                                    'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                                ) ? (
                                    <div className="c-footer-nav__column  js-footer-accordion">
                                        <div className="c-footer-nav__title  js-footer-accordion__title">
                                            <h4 className="c-footer-nav__title-label  js-footer-accordion__title-label">
                                                {t.getTraduction(
                                                    'ExpirationManagement'
                                                )}
                                            </h4>
                                        </div>
                                        <ul className="c-footer-nav__list  js-footer-accordion__panel">
                                            <li className="c-footer-nav__item">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        onClickGoToExpirationMatrix()
                                                    }
                                                >
                                                    {t.getTraduction(
                                                        'ExpirationMatrix'
                                                    )}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                ) : null}
                                <div className="c-footer-nav__column  js-footer-accordion">
                                    <div className="c-footer-nav__title  js-footer-accordion__title">
                                        <h4 className="c-footer-nav__title-label  js-footer-accordion__title-label">
                                            {t.getTraduction('Profile')}
                                        </h4>
                                    </div>
                                    <ul className="c-footer-nav__list  js-footer-accordion__panel">
                                        <li className="c-footer-nav__item">
                                            <a
                                                className="c-footer-nav__link"
                                                onClick={() =>
                                                    onClickGoToProfile(
                                                        'account'
                                                    )
                                                }
                                            >
                                                {t.getTraduction('EditProfile')}
                                            </a>
                                        </li>
                                        <li className="c-footer-nav__item">
                                            <a
                                                className="c-footer-nav__link"
                                                onClick={() =>
                                                    onClickGoToProfile(
                                                        'password'
                                                    )
                                                }
                                            >
                                                {t.getTraduction(
                                                    'CambiarContraseña'
                                                )}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="c-footer-nav__column  js-footer-accordion">
                                    <div className="c-footer-nav__title  js-footer-accordion__title">
                                        <h4 className="c-footer-nav__title-label  js-footer-accordion__title-label">
                                            {t.getTraduction('Contact')}
                                        </h4>
                                    </div>
                                    <ul className="c-footer-nav__list  js-footer-accordion__panel">
                                        {checkPermission(
                                            'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                                        ) ? (
                                            <li className="c-footer-nav__item">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        history.push(
                                                            Globals
                                                                .APPLICATION_PATH
                                                                .CONTACT
                                                        )
                                                    }
                                                >
                                                    {t.getTraduction(
                                                        'AuctionsContact'
                                                    )}
                                                </a>
                                            </li>
                                        ) : null}
                                        {checkPermission(
                                            'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                                        ) ? (
                                            <li className="c-footer-nav__item">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        history.push(
                                                            Globals
                                                                .APPLICATION_PATH
                                                                .CONTACT
                                                        )
                                                    }
                                                >
                                                    {t.getTraduction(
                                                        'ExpirationContact'
                                                    )}
                                                </a>
                                            </li>
                                        ) : null}
                                    </ul>
                                </div>
                                {checkPermission(
                                    'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                                ) ? (
                                    <Fragment>
                                        <div className="c-footer-nav__column">
                                            <div className="c-footer-nav__title  js-footer-accordion__title">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={() =>
                                                        history.push(
                                                            Globals
                                                                .APPLICATION_PATH
                                                                .FAQS
                                                        )
                                                    }
                                                >
                                                    <h4 className="c-footer-nav__title-label  js-footer-accordion__title-label">
                                                        <span className="o-media__img">
                                                            <i className="c-icon  c-icon--xsmall  c-icon--[control-comments]"></i>
                                                        </span>
                                                        {t.getTraduction(
                                                            'Faqs'
                                                        )}
                                                    </h4>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="c-footer-nav__column">
                                            <div className="c-footer-nav__title  js-footer-accordion__title">
                                                <a
                                                    className="c-footer-nav__link"
                                                    onClick={logOff}
                                                >
                                                    <h4 className="c-footer-nav__title-label  js-footer-accordion__title-label">
                                                        <span className="o-media__img">
                                                            <i className="c-icon  c-icon--xsmall  c-icon--[control-logout]"></i>
                                                        </span>
                                                        {t.getTraduction(
                                                            'CerrarSession'
                                                        )}
                                                    </h4>
                                                </a>
                                            </div>
                                        </div>
                                    </Fragment>
                                ) : null}
                            </div>
                        </nav>
                    </div>
                </div>
            ) : null}

            <div className="c-footer__module  c-footer__module--meta-nav">
                <div className="o-page-wrap o-page-wrap--xsmall">
                    <nav className="c-footer-meta-bar">
                        <ul className="c-footer-meta-nav">
                            <li className="c-footer-meta-nav__item">
                                <a
                                    className="c-footer-meta-nav__link"
                                    onClick={() =>
                                        history.push(
                                            Globals.APPLICATION_PATH.LEGAL_NOTE
                                        )
                                    }
                                >
                                    {t.getTraduction('LegalNote')}
                                </a>
                            </li>
                            <li className="c-footer-meta-nav__item">
                                <a
                                    className="c-footer-meta-nav__link"
                                    onClick={() =>
                                        history.push(
                                            Globals.APPLICATION_PATH
                                                .PRIVACY_POLICY
                                        )
                                    }
                                >
                                    {t.getTraduction('PrivacyPolicy')}
                                </a>
                            </li>
                            <li className="c-footer-meta-nav__item">
                                <a
                                    className="c-footer-meta-nav__link"
                                    onClick={() =>
                                        history.push(
                                            Globals.APPLICATION_PATH
                                                .COOKIES_POLICY
                                        )
                                    }
                                >
                                    {t.getTraduction('CookiesPolicy')}
                                </a>
                            </li>
                            <li className="c-footer-meta-nav__item">
                                <a
                                    className="c-footer-meta-nav__link"
                                    onClick={() =>
                                        history.push(
                                            Globals.APPLICATION_PATH.LICENCE
                                        )
                                    }
                                >
                                    {t.getTraduction('ThirdPartyLicenseNotice')}
                                </a>
                            </li>
                        </ul>
                        <span className="c-footer-copyright">
                            <span className="c-footer-copyright__sign">©</span>
                            <span className="c-footer-copyright__text">
                                VWFS {new Date().getFullYear()} v.
                                {packageJson.version}
                            </span>
                        </span>
                    </nav>
                </div>
            </div>

            <div className="c-footer__module  c-footer__module--footnotes">
                <div className="o-page-wrap o-page-wrap--xsmall">
                    <div className="c-footer-footnotes">
                        <p>
                            Volkswagen Financial Services es una marca
                            comercializada por las sociedades Volkswagen Renting
                            S.A., VOLKSWAGEN BANK GmbH Sucursal en España y
                            Volkswagen Insurance Services Correduría de Seguros
                            S.L.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

const mapStateToProps = state => ({
    reduxFilters: state.filters,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({ ...filtersActions }, dispatch),
});

export default withCookies(
    connect(mapStateToProps, mapDispatchToProps)(FooterModule)
);
